import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getPageContent } from '../../Apis/content';

export const GetPage = createAsyncThunk('GetPage', async (formData, { rejectWithValue }) => {
    try {
        const response = await getPageContent(formData);
        // console.log("sow api call response-->",response);
        
        return response;
    } catch (error) {
        return rejectWithValue(error.response);
    }
});


const pageSlice = createSlice({
    name: 'page',
    initialState: {
        error: null,
        success: false,
        data: {},

    },
    reducers: {
        clearAboutuspageStatus: state => {
            state.success = false;
            state.error = null;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(GetPage.pending, state => {
                state.error = null;
                state.success = false;
            })
            .addCase(GetPage.fulfilled, (state, action) => {
                state.success = action.payload;
                state.error = null;
                state.data = action.payload.data.data;
            })
            .addCase(GetPage.rejected, (state, action) => {
                state.error = action.payload;
                state.success = false;
            })
    },

});
export const { clearPageStatus } = pageSlice.actions;
export default pageSlice.reducer;

